import { BASE_URL } from './Constants';
import { useAuthStore } from './stores/useAuthStore';
import { useSessionStore } from './stores/useSessionStore';

interface ApiError extends Error {
    status?: number;
}

export const handleApiError = (error: ApiError) => {
    if (error.status === 401) {
        const { logout } = useAuthStore.getState();
        const { setSessionExpired } = useSessionStore.getState();
        
        // Show the session expired overlay
        setSessionExpired(true);
        
        // Wait for 2 seconds to show the overlay before redirecting
        setTimeout(() => {
            // We'll use window.location instead of useNavigate
            logout(() => {
                window.location.href = '/login';
            });
        }, 2000);
        
        return;
    }
    
    throw error;
};

export const apiClient = {
    get: async (endpoint: string, idToken: string) => {
        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                method: 'GET',
                headers: {
                    'Authorization': idToken
                }
            });

            if (!response.ok) {
                const error: ApiError = new Error('API request failed');
                error.status = response.status;
                throw error;
            }

            return await response.json();
        } catch (error) {
            handleApiError(error as ApiError);
        }
    },

    post: async (endpoint: string, idToken: string, data: any) => {
        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                method: 'POST',
                headers: {
                    'Authorization': idToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                const error: ApiError = new Error('API request failed');
                error.status = response.status;
                throw error;
            }

            return await response.json();
        } catch (error) {
            handleApiError(error as ApiError);
        }
    }
}; 